import { gql } from '@apollo/client';

export const updateQuestionnaireMutation = gql`
  mutation ($id: uuid!, $_set: dans_fund_questionnaire_set_input!) {
    update_dans_fund_questionnaire_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id
    }
  }
`;
